import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../../../store/marketing/publicador/MarketingPublicadorConfig';

import Formsy from 'formsy-react';
import { Row, Modal } from 'react-bootstrap';
import ProgerssBar from '../../../../commons/ProgressBar';
import AlertError from '../../../../commons/AlertError';
import AlertSuccess from '../../../../commons/AlertSuccess';
import InputTextValidated from '../../../../commons/InputTextValidated';
import BtnSalvar from '../../../../commons/BtnSalvar';
import BtnCancelar from '../../../../commons/BtnCancelar';
import OauthPopup from 'react-oauth-popup';

class ModalICarros extends React.Component {
    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.gravarTokenAuth = this.gravarTokenAuth.bind(this);
    }

    async componentDidMount() {
        if (this.props.configuracaoPortais.modalPortais.modalICarros.showModal) {
            if (this.props.configuracaoPortais.modalPortais.ativado) {
                await this.props.fnBuscaConfiguracaoPortal();
                //this.props.configuracaoPortais.modalPortais.modalICarros.access_token = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).token;
                this.props.configuracaoPortais.modalPortais.modalICarros.username = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).username;
                this.props.configuracaoPortais.modalPortais.modalICarros.password = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).password;
                this.props.fnUpdateState(this.props);
            }
            else {
                //this.props.configuracaoPortais.modalPortais.modalICarros.access_token = '';
                this.props.configuracaoPortais.modalPortais.modalICarros.username = '';
                this.props.configuracaoPortais.modalPortais.modalICarros.password = '';
                this.props.fnUpdateState(this.props);
            }
        }
    }

    async handleSubmit(e) {
        var autenticacao = {
            username: this.props.configuracaoPortais.modalPortais.modalICarros.username,
            password: this.props.configuracaoPortais.modalPortais.modalICarros.password
        };

        if (this.props.configuracaoPortais.modalPortais.ativado) {
            await this.props.fnAtualizaConfiguracaoPortal(JSON.stringify(autenticacao), '');
            this.props.configuracaoPortais.modalPortais.modalICarros.showModal = false;
        }
        else {
            await this.props.fnInsereConfiguracaoPortal(JSON.stringify(autenticacao), '');
            this.props.configuracaoPortais.modalPortais.modalICarros.showModal = false;
        }
    }

    async gravarTokenAuth(token) {
        var autenticacao = { token: token };
        await this.props.fnInsereConfiguracaoPortal(JSON.stringify(autenticacao), '');
        this.props.configuracaoPortais.modalPortais.modalICarros.showModal = false;
        this.props.fnUpdateState(this.props);
    }

    handleOnHide() {
        this.props.configuracaoPortais.modalPortais.modalICarros.showModal = false;
        this.props.fnUpdateState(this.props);
    }

    render() {
        return <Modal
            show={this.props.configuracaoPortais.modalPortais.modalICarros.showModal}
            onHide={this.handleOnHide.bind(this)}
        >
            <Formsy onValidSubmit={this.handleSubmit}>
                <Modal.Header closeButton>
                    <h4 className="modal-title custom-font">Configurar ICarros</h4>
                </Modal.Header>
                <Modal.Body>
                    <AlertSuccess
                        successText={this.props.configuracaoPortais.modalPortais.successText}
                        alertVisible={this.props.configuracaoPortais.modalPortais.successText != '' && this.props.configuracaoPortais.modalPortais.successText != undefined ? true : false}
                        onDismiss={(alertVisible, successText) => {
                            this.props.configuracaoPortais.modalPortais.successText = successText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    <AlertError
                        errorText={this.props.configuracaoPortais.modalPortais.errorText}
                        alertVisible={this.props.configuracaoPortais.modalPortais.errorText != '' && this.props.configuracaoPortais.modalPortais.errorText != undefined ? true : false}
                        onDismiss={(alertVisible, errorText) => {
                            this.props.configuracaoPortais.modalPortais.errorText = errorText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    {
                        this.props.configuracaoPortais.modalPortais.isLoading
                            ? <ProgerssBar />
                            : <Row>
                                <div>
                                    <InputTextValidated
                                        name="txtUsuario"
                                        type="text"
                                        className="col-md-12"
                                        placeholder="Informe o email"
                                        onChange={(name, value) => {
                                            this.props.configuracaoPortais.modalPortais.modalICarros.username = value;
                                            this.props.fnUpdateState(this.props);
                                        }}
                                        value={this.props.configuracaoPortais.modalPortais.modalICarros.username}
                                        title="email:"
                                        required
                                    />
                                    <InputTextValidated
                                        name="txtSenha"
                                        type="text"
                                        className="col-md-12"
                                        placeholder="Informe a senha"
                                        onChange={(name, value) => {
                                            this.props.configuracaoPortais.modalPortais.modalICarros.password = value;
                                            this.props.fnUpdateState(this.props);
                                        }}
                                        value={this.props.configuracaoPortais.modalPortais.modalICarros.password}
                                        title="Senha:"
                                        required
                                    />
                                </div>
                            </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {this.props.configuracaoPortais.modalPortais.ativado == true
                        ? <BtnCancelar
                            type="button"
                            text=" Remover Portal"
                            textLoading=" Aguarde..."
                            isLoading={this.props.configuracaoPortais.modalPortais.isLoading}
                            onClick={async () => {
                                await this.props.fnDeleteConfiguracaoPortal();
                                this.props.configuracaoPortais.modalPortais.modalICarros.showModal = false;
                                this.props.fnUpdateState(this.props);
                            }}
                        />
                        : null}
                    <BtnSalvar
                        type="submit"
                        text={this.props.configuracaoPortais.modalPortais.ativado == false ? " Salvar Configuração" : " Alterar Configuração"}
                        textLoading=" Aguarde..."
                        isLoading={this.props.configuracaoPortais.modalPortais.isLoading}
                    />
                </Modal.Footer>
            </Formsy>
        </Modal>;
    }
}

export default connect(
    state => state.marketing_publicadorconfig,
    dispatch => bindActionCreators(actionCreators, dispatch),
    null, {}
)(ModalICarros);